export default __webpack_public_path__ + "static/media/placeholder_dummy2016-anwaltskanzlei01-de.d168d710.png";